var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-default",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return (e => _vm.$emit('click', e)).apply(null, arguments)}}},[(Boolean(_vm.icon))?_c('i',{class:`fa fa-${_vm.icon}`}):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }